import { required } from 'vuelidate/lib/validators'
import { AppPanel } from 'recycle-race-common/lib/enums'
import { vEmail, vLeaderboards, vISODateRange } from 'recycle-race-common/lib/validators'

export const vLogin = {
	email: {
		required,
		email: vEmail,
	},
	password: {
		required,
	},
}

export const vGlobalEvent = {
	leaderboards: {
		required,
		valid: vLeaderboards,
	},
}

export const vEvent = {
	name: {
		required,
	},
	dates: {
		valid: vISODateRange,
	},
	linkTerms: {
		required,
	},
	linkPrivacy: {
		required,
	},
	panels: {
		[AppPanel.PRIZE_TITLE]: {
			required,
		},
		[AppPanel.ENTER_DETAILS_TITLE]: {
			required,
		},
		[AppPanel.THANKS_TITLE]: {
			required,
		},
	},
	leaderboards: {
		required,
		valid: vLeaderboards,
	},
}
